import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { temRecurso, podeVerJuridico } from '../utils/permissoes';

function userHasPermission(login, permission) {
  if (!permission) return true;
  if (permission === 'juridico') return podeVerJuridico(login);
  return temRecurso(login, permission);
}

function ProtectedRoute({ children, permission }) {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const login = useSelector((state) => state.login);

  useEffect(() => {
    if (login.token) {
      const jwtPayload = JSON.parse(window.atob(login.token.split('.')[1]));
      if (Date.now() >= jwtPayload.exp * 1000) {
        setIsLoggedIn(false);
        return navigate('/login');
      }
    }
    if (!login.usuario?.id) {
      setIsLoggedIn(false);
      return navigate('/login');
    }
    // If a permission is required, ensure user has it
    if (permission && !userHasPermission(login, permission)) {
      setIsLoggedIn(false);
      return navigate('/home');
    }
    setIsLoggedIn(true);
  }, [navigate, login.usuario, login.token, permission]);

  return isLoggedIn && children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.element.isRequired,
  permission: PropTypes.string,
};

export default ProtectedRoute;
